// docs: https://github.com/altostra/type-validations#readme
import { objectOf, arrayOf, anyOf } from "@altostra/type-validations";
import { boolean, string, number, maybeString, nullOrUndefined } from "@altostra/type-validations/lib/primitives";

const isCalculatedAttributeDeveloper = anyOf(
  objectOf({
    id: string,
    name: string,
    email: string,
  }),
  nullOrUndefined
);

/** Every field CalculatedAttributeFormatter#calculated_attribute_json emits for both list and detail. */
const calculatedAttributeBaseFields = {
  id: string,
  name: string,
  description: anyOf(maybeString, nullOrUndefined),
  creation_type: string,
  type: string,
  data_type: string,
  is_draft: boolean,
  marked_as_deleted: boolean,
  status: anyOf(maybeString, nullOrUndefined),
  status_reason: anyOf(maybeString, nullOrUndefined),
  data_type_warning: anyOf(maybeString, nullOrUndefined),
  last_processed: anyOf(maybeString, nullOrUndefined),
  last_edited: string,
  last_edited_by: isCalculatedAttributeDeveloper,
  created_at: string,
  created_by: isCalculatedAttributeDeveloper,
  recurring_refresh_enabled: boolean,
  tag_names: arrayOf(string),
};

const isCalculatedAttributeTimeframe = objectOf({
  date_range_type: anyOf(maybeString, nullOrUndefined),
  y_days: anyOf(number, nullOrUndefined),
  start_date: anyOf(maybeString, nullOrUndefined),
  end_date: anyOf(maybeString, nullOrUndefined),
});

/** One branch per subclass's #definition_json. */
const isCalculatedAttributeDefinition = anyOf(
  objectOf({
    aggregation: anyOf(maybeString, nullOrUndefined),
    timeframe: isCalculatedAttributeTimeframe,
  }),
  objectOf({
    template_key: anyOf(maybeString, nullOrUndefined),
    timeframe: isCalculatedAttributeTimeframe,
  }),
  objectOf({
    sql: anyOf(maybeString, nullOrUndefined),
  })
);

export const isCalculatedAttributeDetail = objectOf({
  ...calculatedAttributeBaseFields,
  definition: isCalculatedAttributeDefinition,
});

export const isGetApiCalculatedAttributesAppGroupIdResult = objectOf({
  results: arrayOf(
    objectOf({
      ...calculatedAttributeBaseFields,
      segments_count: number,
    })
  ),
  hits: number,
  max_count: number,
  active_count: number,
});

export const isPostApiCalculatedAttributesAppGroupIdResult = objectOf({
  calculated_attribute: isCalculatedAttributeDetail,
});
